export type CreateLeapPatientEnrollmentRequestData = {
	data: {
		createLeapPatientEnrollmentRequest: {
			serviceEnrollments: {
				name: string;
				requestId: string;
			}[];
			patient: {
				id: string;
			};
		};
	};
};

export type CreateFastTrackLeapEnrollmentRequest = {
	data: {
		createFastTrackEnrollment: {
			status: string;
			service: string;
		};
	};
};

export type ServiceEnrollmentData = {
	service: string;
	state: {
		state: string;
	};
	userSessionId: string;
	card: {
		items: {
			digitalWalletKey: string;
			memberId: string;
			bin: string;
			group: string;
			pcn: string;
		}[];
	};
};

export type OnUpdateServiceEnrollmentData = {
	data: {
		onUpdateServiceEnrollment: ServiceEnrollmentData;
	};
};

export type OnCreateCardData = {
	data: {
		onCreateCard: {
			type: string;
			status: string;
			memberId: string;
			group: string;
			bin: string;
			pcn: string;
			digitalWalletKey: string;
		};
	};
};

export const createLeapPatientEnrollmentRequest = /* GraphQL */ `
	mutation CreateLeapPatientEnrollmentRequest(
		$input: createLeapPatientEnrollmentRequestInput!
	) {
		createLeapPatientEnrollmentRequest(input: $input) {
			serviceEnrollments {
				name
				requestId
			}
			patient {
				id
			}
		}
	}
`;

export const createFastTrackEnrollmentRequest = /* GraphQL */ `
	mutation createFastTrackEnrollment($input: FasttrackEnrollmentInput!) {
		createFastTrackEnrollment(input: $input) {
			status
			service
		}
	}
`;

// FIXME: type should be requested but the backend is failing when done.
// Workaround: Type is being injected to the cards based on service.name
export const onUpdateServiceEnrollment = (token: string) => /* GraphQL */ `
subscription OnUpdateServiceEnrollment {
  onUpdateServiceEnrollment(userSessionId: "${token}") {
    service
    state{
      state
    }
    userSessionId
    card {
      items {
        digitalWalletKey
        memberId
        bin
        group
        pcn
      }  
    }
  }
}`;

export const onCreateCard = (token: string) => /* GraphQL */ `
subscription onCreateCard {
  onCreateCard(userSessionId: "${token}") {
    type
    status
    memberId
    group
    bin
    pcn
    digitalWalletKey
  }
}`;
